document.addEventListener('DOMContentLoaded', () => {
  
  // 1. TELEPORT DRAWER TO BODY
  const drawerElement = document.getElementById('SiteDrawer');
  if (drawerElement && drawerElement.parentNode !== document.body) {
    document.body.appendChild(drawerElement);
  }

  // 2. BULLETPROOF DRAWER TOGGLE
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-drawer-open')) {
      e.preventDefault();
      if(drawerElement) {
        drawerElement.classList.add('is-open');
        document.body.style.overflow = 'hidden'; 
      }
    }
    if (e.target.closest('.js-drawer-close')) {
      e.preventDefault();
      if(drawerElement) {
        drawerElement.classList.remove('is-open');
        document.body.style.overflow = ''; 
      }
    }
  });

  // 3. STICKY HEADER & TRANSPARENT HANDLING
  const header = document.getElementById('StockShopHeader');
  const stickyEnabled = header && header.classList.contains('sticky-enabled');
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (stickyEnabled) {
          if (st > 80) {
            header.classList.add('is-sticky');
          } else {
            header.classList.remove('is-sticky');
          }
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

});